module.exports = __webpack_public_path__ + "static/img/n-test.a551f883.png";